import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import { flowRight as compose } from 'lodash';

// Redux Form
import { Field, reduxForm, change, formValueSelector } from 'redux-form';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

// Graphql
import getPaymentMethodsQuery from './getPaymentMethods.graphql';
import { withQuery } from '../../../hoc/withGraphql';
import Loader from '../../Loader/Loader';

// Locale
import messages from '../../../locale/messages';

import bt from '../../../components/commonStyle.css';
import s from '../Payout.css';

const selector = formValueSelector('PayoutForm');

const PayoutMethods = ({
  handleSubmit,
  previousPage,
  PaymentMethodsData: { loading, getPaymentMethods = [] } = {},
}) => {

  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const paymentMethodId = useSelector((state) => selector(state, 'methodId'));

  useEffect(() => {
    if (
      getPaymentMethods?.results &&
      getPaymentMethods?.results.length > 0 && !paymentMethodId
    ) {
      const activePaymentMethods = getPaymentMethods?.results.find((o) => o?.isEnable);
      if (activePaymentMethods) {
        dispatch(change('PayoutForm', 'methodId', activePaymentMethods.id));
        dispatch(change('PayoutForm', 'paymentType', activePaymentMethods.paymentType));
        dispatch(change('PayoutForm', 'currency', activePaymentMethods.currency));
        if (activePaymentMethods.paymentType === 2) {
          dispatch(change('PayoutForm', 'businessType', 'individual'));
        }
      }
    }
  }, [getPaymentMethods, paymentMethodId, dispatch]);

  const handleChange = (methodId, paymentType, currency) => {
    dispatch(change('PayoutForm', 'methodId', methodId));
    dispatch(change('PayoutForm', 'paymentType', paymentType));
    dispatch(change('PayoutForm', 'currency', currency));
    if (paymentType === 2) {
      dispatch(change('PayoutForm', 'businessType', 'individual'));
    }
  };

  return (
    <div className={cx('inputFocusColor', 'commonListingBg', 'noMarginBottom', 'payoutRadioBtn')}>
      <form onSubmit={handleSubmit}>
        <h3 className={s.titleText}>{formatMessage(messages.addPayout)}</h3>
        <p className={s.payoutIntro}><FormattedMessage {...messages.payoutIntro1} /></p>
        <p className={s.payoutIntro}><FormattedMessage {...messages.payoutIntro2} /></p>

        {loading && <Loader type="text" />}

        {!loading && getPaymentMethods?.results?.length > 0 && (
          <div className={cx('payoutTable', 'NewResponsiveTable', 'mobileTable')}>
            <table className={cx('table', s.noBorder)}>
              <thead>
                <tr className={cx(s.rowBorder, s.sectionTitleLight, s.textTruncate)}>
                  <th scope="col" className={s.noBorder} />
                  <th scope="col" className={s.noBorder}><FormattedMessage {...messages.payoutTitle} /></th>
                  <th scope="col" className={s.noBorder}><FormattedMessage {...messages.payoutTitle1} /></th>
                  <th scope="col" className={s.noBorder}><FormattedMessage {...messages.payoutTitle2} /></th>
                  <th scope="col" className={s.noBorder}><FormattedMessage {...messages.payoutTitle3} /></th>
                  <th scope="col" className={s.noBorder}><FormattedMessage {...messages.payoutTitle4} /></th>
                </tr>
              </thead>
              <tbody>
                {getPaymentMethods.results.map((item, index) =>
                  item.isEnable ? (
                    <tr key={index} className={cx(s.sectionTitleLight)}>
                      <td data-label={formatMessage(messages.payoutTitle)}>
                        <span className={bt.flexCenter}>
                          <Field
                            name="methodId"
                            component="input"
                            value={item.id}
                            type="radio"
                            className={bt.cursorPointer}
                            checked={item.id == paymentMethodId}
                            onChange={() => handleChange(item.id, item.paymentType, item.currency)}
                          />
                          <label className={cx(s.radioText, s.VisibleXS)}>{item.name}</label>
                        </span>
                      </td>
                      <td data-label={formatMessage(messages.payoutTitle)} className={s.hiddenXS}><label className={s.radioText}>{item.name}</label></td>
                      <td data-label={formatMessage(messages.payoutTitle1)}>{item.processedIn}</td>
                      <td data-label={formatMessage(messages.payoutTitle2)}>{item.fees}</td>
                      <td data-label={formatMessage(messages.payoutTitle3)}>{item.currency}</td>
                      <td data-label={formatMessage(messages.payoutTitle4)}>{item.details}</td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </table>
          </div>
        )}
        <div className='doubleBtnFlexEnd'>
          <Button className={cx(bt.btnLarge, bt.btnPrimaryBorder)} onClick={previousPage}>
            <FormattedMessage {...messages.back} />
          </Button>
          <Button className={cx(bt.btnPrimary, bt.btnLarge)} type="submit">
            <FormattedMessage {...messages.next} />
          </Button>
        </div>
        {!loading && getPaymentMethods.results?.length === 0 && (
          <div><FormattedMessage {...messages.noPaymentFound} /></div>
        )}
      </form>
    </div>
  );
};

PayoutMethods.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
  PaymentMethodsData: PropTypes.shape({
    loading: PropTypes.bool,
    getPaymentMethods: PropTypes.shape({
      results: PropTypes.array,
    }),
  }),
};

export default compose(
  withStyles(bt, s),
  reduxForm({
    form: 'PayoutForm', // a unique name for this form
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  withQuery(getPaymentMethodsQuery, {
    name: 'PaymentMethodsData',
    options: { ssr: false },
  })
)(PayoutMethods);